// src/pages/DeviceControlWrapper.jsx
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import DeviceControlPage from "../DeviceControlPage";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export default function DeviceControlWrapper() {
  const { id: deviceId } = useParams();
  const [device, setDevice] = useState(null);
  const [user, setUser] = useState(null);
  const [assetsData, setAssetsData] = useState([]);
  const [error, setError] = useState("");

  const fetchAll = useCallback(async () => {
    try {
      setError("");
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          "x-auth-token": token,
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      };

      const [deviceRes, userRes] = await Promise.all([
        axios.get(`${backendUrl}/devices/${deviceId}`, config),
        axios.get(`${backendUrl}/auth/profile`, config),
      ]);

      setDevice(deviceRes.data);
      setUser(userRes.data?.user || userRes.data);

      // optional (if you have assets endpoint)
      // const assetsRes = await axios.get(`${backendUrl}/assets?deviceId=${deviceId}`, config);
      // setAssetsData(assetsRes.data?.data || []);
      setAssetsData([]);
    } catch (e) {
      console.error(e);
      const status = e?.response?.status;
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.msg ||
        e?.message ||
        "Failed to load device or user profile";
      setError(status ? `${msg} (HTTP ${status})` : msg);
    }
  }, [deviceId]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        <Typography variant="body2" color="text.secondary">
          Please check token / backend URL / deviceId route.
        </Typography>
      </Box>
    );
  }

  if (!device || !user) {
    return (
      <Box sx={{ minHeight: 240, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return <DeviceControlPage device={device} user={user} assetsData={assetsData} onRefresh={fetchAll} />;
}
